import { defineMessages } from 'react-intl';

export default defineMessages({
  emailLabel: {
    id: 'confirmSignupForm.emailLabel',
    defaultMessage: 'Email Address',
  },
  passwordLabel: {
    id: 'confirmSignupForm.passwordLabel',
    defaultMessage: 'Create a new password',
  },
  phoneLabel: {
    id: 'confirmSignupForm.phoneLabel',
    defaultMessage: 'Phone number',
  },
  continueButtonLabel: {
    id: 'confirmSignupForm.continueButtonLabel',
    defaultMessage: 'Continue',
  },
  disabledHelpText: {
    id: 'confirmSignupForm.disabledHelpText',
    defaultMessage: `Your {disabledField} is disabled as its associated with your account. 
      You can change this after your account is set up.`,
  },
  optionalHelpText: {
    id: 'confirmSignupForm.phoneHelpText',
    defaultMessage: `This is optional but we recommend it for improved communications if you make a claim.`,
  },
  emailAddress: {
    id: 'confirmSignupForm.emailAddress',
    defaultMessage: 'email address',
  },
  phoneNumber: {
    id: 'confirmSignupForm.phoneNumber',
    defaultMessage: 'number',
  },
});
